<template xmlns="http://www.w3.org/1999/html">
    <b-modal v-model="visible" size="lg">
        <template v-slot:modal-header="{ close }">
            <div class="row" style="width: 100%">
                <div class="col-md-10 offset-md-1 text-center d-flex justify-content-center">
                    <h3> {{ __('create_group') }} </h3>
                </div>
                <div class="col-md-1">
                    <button type="button" class="close" v-on:click="visible = false">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only">{{ __('close') }}</span>
                    </button>
                </div>
            </div>
        </template>

        <template v-slot:default="{}">
            <div class="row">
                <div class="col-4" :class="{'has-error': error_message }">
                    <label>{{__('group_name')}}</label>
                    <input type="text" v-model="group_name" class="form-control">
                    <span class="help-block text-danger" v-if="error_message">{{ error_message }}</span>
                </div>
            </div>

        </template>
        <template v-slot:modal-footer="{}">
            <div class="row m-b">
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-white" v-on:click="visible = false">{{__('cancel')}}</button>
                </div>
                <div class="col white-space-no-wrap">
                    <button type="button" class="btn btn-primary" @click="saveGroup()">{{__('OK')}}</button>
                </div>
            </div>
        </template>
    </b-modal>
</template>

<script>
import axios from "axios";
import Numeric from "vuelidate/lib/validators/numeric";

export default {
    name: "ModalCreateItemGroup",
    data: function () {
        return {
            visible: false,
            itemGroups: [],
            group_name:null,
            error_message : null,
        }
    },
    props:{
        area:{
            type:String,
        },
        itemsAndGroups: {
            type: Array,
            default: [],
        },
        patternId:{
            type:Numeric,
            default: null,
        }
    },
    methods:{
        saveGroup(){
            const self = this;
            toggleLoader()
            axios.post("/analyze/item-group/store", {
                'group_name': self.group_name,
                'area':self.area,
                'pattern_id': self.patternId
            }).then(function (response) {
                if(response.data.status == 'fail'){
                    toggleLoader(false)
                    self.error_message = response.data.message;
                }
                else{
                    self.handleGroupAdded(response.data.group_name)
                    self.visible = false;
                    toggleLoader(false)
                    self.$emit('itemGroupAdded', self.itemsAndGroups)
                }

            });
        },
        handleGroupAdded(groupName){
            let indexUnallocatedGroup = this.itemsAndGroups.findIndex(group=>group.name == 'unallocated');
            if(indexUnallocatedGroup == -1){
                this.itemsAndGroups.push({name:groupName, standard_items:[]})
            }
            else{
                const lastElement = this.itemsAndGroups.pop(); // Usunięcie ostatniego elementu
                this.itemsAndGroups.push({name:groupName, standard_items:[]});
                this.itemsAndGroups.push(lastElement)
            }
        }
    }
}
</script>

<style scoped>

</style>
